import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { loadTranslations } from '@angular/localize';
import { platformBrowser } from '@angular/platform-browser';

import { environment } from '@env';
import { LocaleLoader } from '@locale';

if (environment.production) {
  enableProdMode();
}

LocaleLoader()
  .then(data => loadTranslations(data))
  .then(() => {
    return import('./app/app.module');
  })
  .then(module => {
    platformBrowser().bootstrapModule(module.AppModule, { applicationProviders: [provideZoneChangeDetection({ eventCoalescing: true })], })
      .catch(err => console.error(err));
  });
